import { Truck, Star } from "lucide-react";

/**
 * TopBar — slim black announcement strip above header, CENTERED.
 */
export const TopBar = () => (
  <div
    data-testid="topbar"
    className="fixed top-0 left-0 right-0 z-[60] bg-black text-white"
  >
    <div className="px-4 md:px-8 lg:px-12 h-8 md:h-9 flex items-center justify-center gap-4 text-[11px] md:text-[12px]">
      <div className="flex items-center gap-2 min-w-0">
        <Truck className="w-3.5 h-3.5 shrink-0 text-[#25D366]" />
        <span className="font-medium tracking-tight text-center">
          Ihr Partner für günstige Entrümpelungen &amp; Schrottabholung
        </span>
        <span className="hidden md:inline-flex items-center gap-1.5 ml-3 pl-3 border-l border-white/15">
          <Star className="w-3 h-3 fill-[#25D366] text-[#25D366]" />
          <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/80">
            4.9 · Google
          </span>
        </span>
      </div>
    </div>
  </div>
);
